import React from 'react';
import './Testimonial.css';

const Testimonial = () => {
  return (
    <section id="testimonials" class="testimonials-section">
		  <h2 class="testimonials-title">Ils ont fait appel à moi</h2>
		  <div class="testimonials-container">
		  {/*<div class="testimonial-card">
			  <p class="testimonial-text">
				« Johane a su répondre à nos attentes avec des affiches créatives et adaptées à l’univers de notre boutique. En plus, sa présentation des jeux lors du salon du livre de poche a captivé les visiteurs et renforcé notre visibilité.<br />Une collaboration fluide et inspirante ! »
			  </p>
			  <p class="testimonial-author">Brice<br />Gérant de Bazar du Bizarre</p>
		  </div>*/}
			<div class="testimonial-card">
			  <p class="testimonial-text">
				« En peu de temps, Johane est devenue une personne indispensable à notre association, gérant avec succès les thèmes et décorations de nos soirées, tout en animant avec brio les tables de jeux auprès de nos adhérents.<br />Un atout majeur ! »
			  </p>
			  <p class="testimonial-author">Timothée<br />Président de l’association Mines de Jeux</p>
			</div>
			<div class="testimonial-card">
			  <p class="testimonial-text">
				« C’était un plaisir de collaborer ensemble ; Nous recommandons,<br />c’est du très bon travail.<br />Vivement la prochaine occurrence !! »
			  </p>
			  <p class="testimonial-author">Jérôme<br />Fondateur de On The Board Again</p>
			</div>
		  </div>
	</section>
  );
};

export default Testimonial;